import types from './types';

export const setShelterName = shelterName => ({
  type: types.SET_SHELTERT_NAME,
  shelterName
});

export const setEntryKubun = entryKubun => ({
  type: types.SET_ENTRY_KUBUN,
  entryKubun
});

 export default {
  setEntryKubun,
  setShelterName
 };
